export const ROLES_RECEIVED = "ROLES_RECEIVED";